import { type IIcon, EIcons } from '@/app/types/iconType'

import { Close } from './svg/Close'
import { Edit } from './svg/Edit'
import { HidePassword } from './svg/HidePassword'
import { LoadingData } from './svg/LoadingData'
import { Logo } from './svg/Logo'
import { Logo2 } from './svg/Logo2'
import { Minus } from './svg/Minus'
import { Note } from './svg/Note'
import { Pen } from './svg/Pen'
import { PhotoDevice } from './svg/PhotoDevice'
import { Plus } from './svg/Plus'
import { Save } from './svg/Save'
import { Search } from './svg/Search'
import { SeePassword } from './svg/SeePassword'
import { Trash } from './svg/Trash'
import { Trash2 } from './svg/Trash2'
import { TriangleArrow } from './svg/TriangleArrow'

export const Icon = (props: IIcon) => {
    const { iconName, ...rest } = props
    switch (iconName) {
        case EIcons.CLOS:
            return <Close {...rest} />
        case EIcons.EDIT:
            return <Edit {...rest} />
        case EIcons.LOGO:
            return <Logo {...rest} />
        case EIcons.LOGO2:
            return <Logo2 {...rest} />
        case EIcons.PEN:
            return <Pen {...rest} />
        case EIcons.PDVCE:
            return <PhotoDevice {...rest} />
        case EIcons.PLUS:
            return <Plus {...rest} />
        case EIcons.Minus:
            return <Minus {...rest} />
        case EIcons.Note:
            return <Note {...rest} />
        case EIcons.TRSH:
            return <Trash {...rest} />
        case EIcons.TRSH2:
            return <Trash2 {...rest} />
        case EIcons.AROW:
            return <TriangleArrow {...rest} />
        case EIcons.SAVE:
            return <Save {...rest} />
        case EIcons.SRCH:
            return <Search {...rest} />
        case EIcons.SEEPSWRD:
            return <SeePassword {...rest} />
        case EIcons.HIDPSWRD:
            return <HidePassword {...rest} />
        case EIcons.LOAD:
            return <LoadingData {...props} />

        default:
            return <div>404</div>
    }
}
